"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _pageLink = require("../page-link");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _helpers = require("../../helpers");

var _jsxFileName = "D:\\DXC\\Digital.UI.CommonStyling\\src\\lib\\components\\footer\\index.jsx";
//import { Helmet } from "react-helmet";
const FooterEditConfig = {
  emptyLabel: "Farmlands Footer Component",
  isEmpty: function (props) {
    return !(props.logoLink || props.fileReference || props.phone || props.email);
  }
};
const FooterStyling = _styledComponents.default.footer`
.Footer__top-container {
  background-color: ${props => props === null || props === void 0 ? void 0 : props.topBackgroundColor}
}

.Footer__top-text,
  .Footer__top-text a,
  .Footer__top-text a:hover,
  .Footer__top-text ul li a,
  .Footer__top-text ul li a:hover {
    color: ${props => props === null || props === void 0 ? void 0 : props.topTextColor};
  }

  .Footer__bottom-container--mobile {
    background-color: ${props => props === null || props === void 0 ? void 0 : props.bottomBackgroundColorMobile};
  }

  .Footer__bottom-container--desktop {
    background-color: ${props => props === null || props === void 0 ? void 0 : props.bottomBackgroundColorDesktop};
  }

  .Footer__bottom-container--mobile,
  .Footer__bottom-bar__links--mobile li a,
  .Footer__bottom-bar__links--mobile li a:hover {
    color: ${props => props === null || props === void 0 ? void 0 : props.bottomTextColorMobile};
  }

  .Footer__bottom-container--desktop,
  .Footer__bottom-bar__links--desktop li a,
  .Footer__bottom-bar__links--desktop li a:hover {
    color: ${props => props === null || props === void 0 ? void 0 : props.bottomTextColorDesktop};
  }

  .Footer__contact__social-icon {
    background-color: ${props => props === null || props === void 0 ? void 0 : props.socialBackgroundColor};
  }
`;
/**
 * Footer component used on all pages.
 */

const CommonFooter = props => {
  var _props$trackClick;

  // Components/methods that will be the responsibility of the host application to pass through
  const trackClick = (_props$trackClick = props === null || props === void 0 ? void 0 : props.trackClick) !== null && _props$trackClick !== void 0 ? _props$trackClick : null;
  const [activeClass, setActiveClass] = (0, _react.useState)("");
  const [elementHeight, setElementHeight] = (0, _react.useState)("0px");
  const [currentSelection, setCurrentSelection] = (0, _react.useState)("");
  const [width, setWidth] = (0, _react.useState)(window.innerWidth);
  (0, _react.useEffect)(() => {
    var head = document.getElementsByTagName('head')[0];
    const script = document.createElement("script");
    script.src = "https://staticcdn.co.nz/embed/embed.js";
    script.async = true;
    head.appendChild(script);
    const head2 = document.getElementsByTagName('head')[0];
    const script2 = document.createElement("script");
    script2.textContent = `
                            var frameNameMobile = new ds07o6pcmkorn({
                              openElementId: "#shielded-logo-mobile",
                              modalID: "modal-mobile",
                            });
                            
                            var frameNameDesktop = new ds07o6pcmkorn({
                              openElementId: "#shielded-logo-desktop",
                              modalID: "modal-desktop",
                            });
                            
                            frameNameMobile.init();
                            frameNameDesktop.init();
                    `;
    setTimeout(function () {
      head2.appendChild(script2);
    }, 5000);
  }, []);
  (0, _react.useEffect)(() => {
    const handleWindowSizeChange = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowSizeChange);
  }, [setWidth]);

  const toggleLinkGroup = index => {
    const active = !document.getElementById("group-" + index).classList.contains("active");
    setActiveClass(active ? "active" : "");
    setCurrentSelection(index);
    setElementHeight(active ? document.getElementById("grouplist-" + index).scrollHeight + "px" : "0px");
  };

  const footerLogo = () => {
    if (!(props.logoLink || props.fileReference) || !(props.logoLink === "" || props.fileReference !== "")) {
      return null;
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "Footer__logo-container",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 130,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
      to: props.logoLink,
      label: "Logo link",
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e, "Footer logo"),
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 131,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "Footer__logo",
      src: (0, _helpers.resolveAsset)(props === null || props === void 0 ? void 0 : props.fileReference),
      alt: "farmland-portal",
      width: "100%",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 138,
        columnNumber: 11
      }
    })));
  };

  const contactUsHeader = () => {
    const {
      contactUsLink
    } = props;

    if (contactUsLink) {
      if (contactUsLink.path && contactUsLink.path !== "") {
        return /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
          to: contactUsLink.path,
          label: contactUsLink.label,
          target: contactUsLink.target,
          onClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e),
          onAuxClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e),
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 155,
            columnNumber: 11
          }
        }, contactUsLink.label);
      } else {
        return contactUsLink.label;
      }
    }

    return "";
  };

  const contactDetails = screenSize => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "Footer__contact",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 174,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "Footer__contact__details",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 175,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "Footer__contact__details__heading Footer__top-text",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 176,
        columnNumber: 11
      }
    }, contactUsHeader()), /*#__PURE__*/_react.default.createElement("div", {
      className: "Footer__contact__details__phone Footer__top-text",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 179,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "tel:" + props.phone,
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 180,
        columnNumber: 13
      }
    }, props.phone)), /*#__PURE__*/_react.default.createElement("div", {
      className: "Footer__contact__details__email Footer__top-text",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 182,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "mailto:" + props.email,
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 183,
        columnNumber: 13
      }
    }, props.email))), /*#__PURE__*/_react.default.createElement("div", {
      className: "Footer__contact__social-media",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 186,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "Footer__contact__social-media__signup Footer__top-text",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 187,
        columnNumber: 11
      }
    }), (props.facebookLink || props.instagramLink || props.linkedInLink) && /*#__PURE__*/_react.default.createElement("div", {
      className: "Footer__contact__social-media__links",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 190,
        columnNumber: 13
      }
    }, props.facebookLink && /*#__PURE__*/_react.default.createElement("a", {
      href: props.facebookLink,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e, "Footer Facebook icon"),
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 192,
        columnNumber: 17
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: "Facebook icon",
      className: "\r Footer__contact__social-icon\r Footer__contact__social-icon--facebook\r ",
      src: (0, _helpers.resolveAsset)(props === null || props === void 0 ? void 0 : props.facebookIcon),
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 200,
        columnNumber: 19
      }
    })), props.linkedInLink && /*#__PURE__*/_react.default.createElement("a", {
      href: props.linkedInLink,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e, "Footer LinkedIn icon"),
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 211,
        columnNumber: 17
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: "LinkedIn icon",
      className: "\r Footer__contact__social-icon\r Footer__contact__social-icon--linkedin\r ",
      src: (0, _helpers.resolveAsset)(props === null || props === void 0 ? void 0 : props.linkedInIcon),
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 219,
        columnNumber: 19
      }
    })), props.instagramLink && /*#__PURE__*/_react.default.createElement("a", {
      href: props.instagramLink,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e, "Footer Instagram icon"),
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 230,
        columnNumber: 17
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: "Instagram icon",
      className: "\r Footer__contact__social-icon\r Footer__contact__social-icon--instagram\r ",
      src: (0, _helpers.resolveAsset)(props === null || props === void 0 ? void 0 : props.instagramIcon),
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 238,
        columnNumber: 19
      }
    })), /*#__PURE__*/_react.default.createElement("a", {
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 248,
        columnNumber: 15
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "Footer__contact__social-icon",
      alt: "shielded",
      id: `shielded-logo-${screenSize}`,
      src: "https://shielded.co.nz/img/custom-logo.png",
      height: "60",
      width: "60",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 249,
        columnNumber: 17
      }
    })))));
  };

  const footerLinkGroup = () => {
    var _props$linkGroupList;

    const isTablet = width <= 900;
    return props === null || props === void 0 ? void 0 : (_props$linkGroupList = props.linkGroupList) === null || _props$linkGroupList === void 0 ? void 0 : _props$linkGroupList.map((data, index) => {
      var _data$linkList;

      return /*#__PURE__*/_react.default.createElement("div", {
        key: index,
        className: "Footer__column",
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 270,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "Footer__link-group",
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 271,
          columnNumber: 11
        }
      }, !isTablet ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "Footer__link-group__label Footer__top-text",
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 274,
          columnNumber: 17
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 275,
          columnNumber: 19
        }
      }, data.linkGroupLabel !== null ? data.linkGroupLabel : null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "Footer__link-list Footer__top-text",
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 279,
          columnNumber: 17
        }
      }, /*#__PURE__*/_react.default.createElement("ul", {
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 280,
          columnNumber: 19
        }
      }, data.linkList.map((value, index) => {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: index,
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 283,
            columnNumber: 25
          }
        }, /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
          to: value.path,
          label: value.label,
          target: value.target,
          onClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e),
          onAuxClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e),
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 284,
            columnNumber: 27
          }
        }, value.label));
      })))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        id: "group-" + index,
        className: `Footer__link-group__label Footer__top-text ${index === currentSelection ? activeClass : ""} `,
        onClick: () => toggleLinkGroup(index),
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 301,
          columnNumber: 17
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 307,
          columnNumber: 19
        }
      }, data.linkGroupLabel), /*#__PURE__*/_react.default.createElement("i", {
        className: "Footer__link-group__label__dropdown material-icons",
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 308,
          columnNumber: 19
        }
      }, "arrow_drop_down")), /*#__PURE__*/_react.default.createElement("div", {
        id: "grouplist-" + index,
        className: "Footer__link-list Footer__top-text",
        style: {
          maxHeight: index === currentSelection ? elementHeight : `0px`,
          opacity: 1
        },
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 312,
          columnNumber: 17
        }
      }, /*#__PURE__*/_react.default.createElement("ul", {
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 321,
          columnNumber: 19
        }
      }, data === null || data === void 0 ? void 0 : (_data$linkList = data.linkList) === null || _data$linkList === void 0 ? void 0 : _data$linkList.map((value, index) => {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: index,
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 324,
            columnNumber: 25
          }
        }, /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
          to: value.path,
          label: value.label,
          target: value.target,
          onClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e),
          onAuxClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e),
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 325,
            columnNumber: 27
          }
        }, value.label));
      }))))));
    });
  };

  const footerBottomBar = isDesktop => {
    var _props$bottomBarLinkL;

    const listClass = (0, _classnames.default)('Footer__bottom-bar__links', {
      'Footer__bottom-bar__links--mobile row': !isDesktop,
      'Footer__bottom-bar__links--desktop': isDesktop
    });
    const itemClass = (0, _classnames.default)({
      'col-12': !isDesktop
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "Footer__bottom-bar",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 357,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 358,
        columnNumber: 9
      }
    }, "Copyright \xA9 Farmlands Co-operative Society Limited ", props.currentYear, " | All rights reserved"), /*#__PURE__*/_react.default.createElement("ul", {
      className: listClass,
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 361,
        columnNumber: 9
      }
    }, props === null || props === void 0 ? void 0 : (_props$bottomBarLinkL = props.bottomBarLinkList) === null || _props$bottomBarLinkL === void 0 ? void 0 : _props$bottomBarLinkL.map((data, index) => {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: index,
        className: itemClass,
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 364,
          columnNumber: 15
        }
      }, /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
        to: data.path,
        label: data.label,
        target: data.target,
        onClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e),
        onAuxClick: e => trackClick === null || trackClick === void 0 ? void 0 : trackClick(e),
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 365,
          columnNumber: 17
        }
      }, data.label));
    })));
  };

  if (FooterEditConfig.isEmpty(props)) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }

  return /*#__PURE__*/_react.default.createElement(FooterStyling, Object.assign({}, props, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 387,
      columnNumber: 5
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "Footer",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 388,
      columnNumber: 7
    }
  }, !props.thinFooter && /*#__PURE__*/_react.default.createElement("div", {
    className: "Footer__top-container",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 390,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 391,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Footer__row",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 392,
      columnNumber: 15
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Footer__column",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 393,
      columnNumber: 17
    }
  }, footerLogo()), /*#__PURE__*/_react.default.createElement("div", {
    className: "Footer__column Footer__contact-column Footer__contact-column--mobile",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 394,
      columnNumber: 17
    }
  }, contactDetails('mobile')), footerLinkGroup(), /*#__PURE__*/_react.default.createElement("div", {
    className: "Footer__column Footer__contact-column Footer__contact-column--desktop",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 398,
      columnNumber: 17
    }
  }, contactDetails('desktop')))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "Footer__bottom-container Footer__bottom-container--mobile",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 406,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 407,
      columnNumber: 9
    }
  }, footerBottomBar(false))), /*#__PURE__*/_react.default.createElement("div", {
    className: "Footer__bottom-container Footer__bottom-container--desktop",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 409,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 410,
      columnNumber: 9
    }
  }, footerBottomBar(true))));
};

var _default = CommonFooter;
exports.default = _default;